import { stripeTableRef } from '.';
import randomId from 'random-id';

export default function (editor, opts = {}) {
  const { labelShoppingCartCategory, pfx, labels, types } = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  .${pfx} {
    padding: 2px;
  }
  </style>
`;
  if (opts.blocks.indexOf(stripeTableRef) >= 0) {
    const tableId = 'dc-data-table-' + randomId(8, '');
    let tableHeadingCells = '';
    let tableBodyCells = '';

    const fields = [
      { name: 'name', label: 'Name' },
      { name: 'card_number', label: 'Card Number' },
      { name: 'exp_month', label: 'Expire Month' },
      { name: 'exp_year', label: 'Expire Year' },
      { name: 'brand', label: 'Brand' },
      { name: 'email', label: 'Email' },
      { name: 'country', label: 'Country' },
    ];

    fields.forEach((field) => {
      tableHeadingCells += `<th type="text"><div title="${field.label}" >${field.label}</div></th>`;
      tableBodyCells += ` <td value="${field.name}" ><div>${field.label}'s value</div></td>`;
    });
    tableHeadingCells += `<th scope="col" type="action"><div>Actions</div></th>`;
    tableBodyCells += `<td scope="col" value="ACTION" type="action">
                            <a href="" class="btn btn-primary btn-sm" style="margin: 0px 2px">Edit</a>
                            <a href="" class="btn btn-danger btn-sm" style="margin: 0px 2px">Delete</a>
                       </td>`;

    bm.add(stripeTableRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="32" height="50" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1664 1408"><path d="M512 1248v-192q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V672q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 480V288q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V672q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768V288q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V672q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V288q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47H160q-66 0-113-47T0 1248V160Q0 94 47 47T160 0h1344q66 0 113 47t47 113z" fill="#c3cfe9"/></svg>
          <div class="gjs-block-label">${labels.stripeList}</div>`,
      category: labelShoppingCartCategory,
      content: `
        <div class='${pfx} p-3 table-responsive' data-js="${types.stripeList}" data-gjs-type="${types.stripeList}">
            <table id="${tableId}" class="table table-bordered table-resizable">
                <thead>
                    <tr>${tableHeadingCells}</tr>
                </thead>
                <tbody>
                    <tr>${tableBodyCells}</tr>
                </tbody>
            </table>
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
      `,
    });
  }
}
